module.exports = __webpack_public_path__ + "img/eleganza.6605dbb1.png";